module.exports = __webpack_public_path__ + "media/images/icons/trustpilot-92331c3fcc1864c8da818f3aa2bc99c8.svg";